import { createContext, type ReactNode, useContext, useState } from "react";

import { useNotifications, type NotificationDetail } from "./hooks";

type NotificationSummary = {
  notifications: NotificationDetail[];
  total: number;
  dismissAllNotifications: () => void;
};

const NotificationContext = createContext<NotificationSummary | null>(null);

export const useNotificationContext = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx)
    throw new Error(
      "useNotifications must be used within NotificationProvider",
    );
  return ctx;
};

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [notificationsDismissed, setNotificationsDismissed] = useState(false);
  const notifications = useNotifications();

  const dismissAllNotifications = () => {
    setNotificationsDismissed(true);
  };

  const activeNotifications = notifications.filter((notif) => !notif.dismissed);

  const value: NotificationSummary = {
    notifications: notificationsDismissed ? [] : activeNotifications,
    total: notificationsDismissed ? 0 : activeNotifications.length,
    dismissAllNotifications,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};
